export * from './history'
export * from './staticPage'

export const PAGINATION = {
    START_PAGE: 1,
    DEFAULT_PER_PAGE: 10,
}

export const PROVIDER_OPEN_HTML_TYPE = ['pgsoft']

export const MODAL = {
    LOGIN: 'login',
    REGISTER: 'register',
}

export const MODAL_TYPE = {
    ERROR: 'error',
    SUCCESS: 'success',
}

export const HEADER_MB_HIDDEN_ROUTES = ['user-p2p', 'support-slug', 'help-slug']

export const IMAGE_LINK_DEFAULT = 'assets/images/img-default.webp'

export const CURRENCY = {
    VND: 'VND',
    UNIT: 'K',
    RATE: 1000,
}

export const COUNTDOWN = {
    DOUBLE_ZERO: '00',
    ZERO: '0',
    MINUS_ONE: '-1',
}
export const COUNTDOWN_NAN = '-'

export const actionsFilterTransaction = {
    withdraw: 'WITHDRAW',
    deposit: 'DEPOSIT',
}
export const statusTransaction = {
    maintenance: 'MAINTENANCE',
    proposed: 'PROPOSED',
}
export const statusTransactionMapping = {
    [statusTransaction.maintenance]: {
        text: 'Bảo trì',
        color: 'is-maintenance',
    },
    [statusTransaction.proposed]: {
        text: 'Đề xuất',
        color: 'is-proposed',
    },
}
